var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-stepper d-none" }, [
    _c(
      "div",
      { staticClass: "cd-stepper font-weight-bold" },
      [
        _vm._l(_vm.steps, function(i) {
          return [
            _c(
              "div",
              {
                key: " step" + i,
                class:
                  "stepper text-center d-none d-xl-block" +
                  (i === _vm.currentStep ? " active d-block" : "")
              },
              [
                _c(
                  "div",
                  { class: "step" + (i === _vm.currentStep ? " active" : "") },
                  [_vm._v(" " + _vm._s(i) + " ")]
                ),
                _c("p", { staticClass: "pt-1" }, [
                  _vm._v(_vm._s(_vm.getStepLabel(i)))
                ])
              ]
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }